
@custom-media --mobile (max-width: 768px);

.container {
  margin-top: 2em;
}

.row {
  & td {
    padding: 2em 1.5em;
    min-width: 5em;
  }
}

.listing {
  font-weight: bold;
  font-size: 0.8em;
  margin-bottom: 4em;

  @media (--mobile) {
    margin-bottom: 2em;
  }
}

.row:nth-child(odd) {
  background-color: var(--silver);
}

.row:nth-child(even),
.rowHeader {
  background-color: var(--white);
}

.selectableRow {
  cursor: pointer;

  &:hover {
    background-color: var(--mediumSilver);
  }
}

.header {
  & th {
    font-weight: bold !important;
    padding-bottom: 0 !important;
  }
}

.link {
  font-weight: bold;
}
